<template>
  <div class="install-box elevation-4">
    <v-btn
      class="ml-2"
      size="large"
      color="primary"
      @click="$emit('install')"
    >
      <v-icon class="mr-2">mdi-download</v-icon>
      {{ $t('btn.install_app') }}
    </v-btn>
    <v-btn
      icon
      class="ml-8"
      @click="$emit('close')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'InstallBox',
  props: {
    show: Boolean,
  },
  emits: ['install', 'close'],
}
</script>

<style lang="scss" scoped>
.install-box {
  width: 100vw;
  background: var(--clr-black-1);
  padding: 1rem 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}
</style>
